<template>
  <div>
    <div v-if="detail && detail.list && detail.list.length">
      <van-cell-group>
        <van-cell :value="detail.courseName" class="van-cell--center" v-show="showTitle"/>
        <van-cell :value="detail.list[0].absentCount + ' 次'">
          <template slot="title">
            <tn-tag :title="stuStatus[1].label" :type="stuStatus[1].type"></tn-tag>
            旷课
          </template>
        </van-cell>
        <van-cell :value="detail.list[0].lateCount + ' 次'">
          <template slot="title">
            <tn-tag :title="stuStatus[2].label" :type="stuStatus[2].type"></tn-tag>
            迟到
          </template>
        </van-cell>
        <van-cell :value="detail.list[0].leaveAbsentCount + ' 次'">
          <template slot="title">
            <tn-tag :title="stuStatus[3].label" :type="stuStatus[3].type"></tn-tag>
            早退
          </template>
        </van-cell>
        <van-cell :value="detail.list[0].leaveCount + ' 次'">
          <template slot="title">
            <tn-tag :title="stuStatus[4].label" :type="stuStatus[4].type"></tn-tag>
            请假
          </template>
        </van-cell>
        <van-cell :value="detail.list[0].rightCount + ' 次'">
          <template slot="title">
            <tn-tag :title="stuStatus[0].label" :type="stuStatus[0].type"></tn-tag>
            正常
          </template>
        </van-cell>
      </van-cell-group>
    </div>
    <div v-else class="empty-info">暂无签到信息</div>
  </div>

</template>
<script>
  export default {
    name: 'sign-in-detail',
    props: {
      detail: Object,
      showTitle: {
        type: Boolean,
        default: true
      }
    },
    computed: {
      stuStatus() {
        return this.$store.state.stuStatus;
      }
    }
  };
</script>
